import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SavePhoneMutation = gql`
   mutation SavePhone($phone: PhoneInput!) {
      phone: savePhone(phone: $phone) {
         phoneId
         phoneType
         extensionId
         handsetIpei
         sipUsersConnection {
            items {
               sipUserId
               userName
               hashPassword
               phoneId
            }
         }
         baseStationHandsetsConnection {
            items {
               baseStationHandsetId
               phoneId
               deviceId
               sortId
            }
         }
      }
   }
`;
